import React from 'react';
import HireUs from 'views/HireUs';

const HireUsPage = () => {
  return <HireUs />;
};

export default HireUsPage;
